<script setup lang="ts">
import { computed } from "vue";
import { useAlertStore } from "@/shared/store/alert_store";

const alertStore = useAlertStore();

const dialogConfig = computed(() => alertStore.alertDialogConfig);
const isFeedbackDialog = computed(
  () => dialogConfig.value?.variant === "feedback"
);

const handleConfirm = () => {
  alertStore.emitAlertDialogEvent(true);
  alertStore.hideAlertDialog();
};

const handleCancel = () => {
  alertStore.emitAlertDialogEvent(false);
  alertStore.hideAlertDialog();
};
</script>

<template>
  <v-dialog
    v-model="alertStore.isAlertDialogVisible"
    max-width="640"
    persistent
  >
    <v-card class="alert-dialog-card rounded-xl pa-8">
      <v-card-title class="text-h6 text-center font-weight-bold pa-0">
        {{ dialogConfig?.title }}
      </v-card-title>

      <v-card-text
        v-if="dialogConfig?.message"
        class="text-body-2 text-center mt-3"
      >
        {{ dialogConfig.message }}
      </v-card-text>

      <v-card-actions class="justify-center mt-6">
        <v-btn
          v-if="!isFeedbackDialog"
          variant="outlined"
          class="alert-dialog-btn alert-dialog-btn-cancel"
          @click="handleCancel"
        >
          {{ dialogConfig?.cancelLabel }}
        </v-btn>
        <v-btn
          color="primary"
          class="alert-dialog-btn alert-dialog-btn-confirm"
          @click="handleConfirm"
        >
          {{ dialogConfig?.confirmLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-snackbar
    v-if="alertStore.getTypeAlert"
    v-model="alertStore.isDialogVisible"
    color="success"
    timeout="4000"
    class="v-snack-bar"
    multi-line
    rounded="lg"
    max-width="150px"
    @click="alertStore.hideDialogAlert"
    ><v-row>
      <span class="text-white mx-4" style="font-size: 14px">
        {{ alertStore.getAlertMessage }}
      </span>
    </v-row>
  </v-snackbar>
  <v-snackbar
    v-else
    v-model="alertStore.isDialogVisible"
    color="error"
    timeout="4000"
    class="v-snack-bar"
    multi-line
    rounded="lg"
    max-width="150px"
    @click="alertStore.hideDialogAlert"
  >
    <template #default>
      <v-row>
        <span class="text-white mx-4" style="font-size: 18px">Atenção:</span>
      </v-row>
      <v-row>
        <span class="text-white mx-4 my-1" style="font-size: 14px">
          {{ alertStore.getAlertMessage }}
        </span>
      </v-row>
    </template>
  </v-snackbar>
</template>

<style scoped>
.alert-dialog-card {
  background-color: #ffffff;
}

.alert-dialog-btn {
  min-width: 180px;
  border-radius: 999px;
  font-weight: 600;
  text-transform: none;
  height: 44px;
}

.alert-dialog-btn-cancel {
  border-color: #f7901e;
  color: #f7901e;
  background-color: #f9f2ea;
}

.alert-dialog-btn-confirm {
  background-color: #f7a21b !important;
  color: #2f2f2f !important;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .v-snack-bar {
    right: 0% !important;
  }
}
@media screen and (min-width: 481px) and (max-width: 768px) {
  .v-snack-bar {
    right: -30% !important;
  }
}
@media screen and (min-width: 769px) and (max-width: 1024px) {
  .v-snack-bar {
    right: -50%;
  }
}
@media screen and (min-width: 1025px) and (max-width: 1200px) {
  .v-snack-bar {
    right: -70%;
  }
}
@media screen and (min-width: 1201px) {
  .v-snack-bar {
    right: -72%;
  }
}
</style>
